import { UserTypes } from '@shared/enums';
import { Setor, User } from '@shared/models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultRequest } from '@shared/utils/consult-request';
import { VisitasService } from '@modules/visitas/services/visitas.service';

@Component({
  selector: 'app-setor-combo',
  templateUrl: './setor-combo.component.html',
  styleUrls: ['./setor-combo.component.css']
})
export class SetorComboComponent implements OnInit {
  @Input() setor: Setor = null;
  @Output() setorChange = new EventEmitter<Setor>();

  @Input() required = false;

  setoresRequest = new ConsultRequest<Setor[]>();

  userLogado: User;
  UserTypes = UserTypes
  isDisabled = false;

  constructor(
    private visitService: VisitasService,
  ) {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);
    this.isDisabled = this.userLogado.perfil ==  UserTypes.GESTOR || this.userLogado.perfil  === UserTypes.VENDEDOR

    if(this.isDisabled){
      const {idSetor, setor} = this.userLogado;
      console.log(setor);

      this.setor = {
        id: idSetor,
        codigo: setor,
      }

      this.handleSetorChange()
    }
  }

  ngOnInit() {
    if(!this.isDisabled){
      this.getSetores()
    }
  }

  handleSetorChange(){
    this.setorChange.emit(this.setor)
  }

  // metodos privados

  private getSetores() {
    this.setoresRequest.get(
      this.visitService.getSetores()
    )
  }

}

